var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"option",on:{"click":_vm.toggle}},[_c('div',{staticClass:"toggle",class:[{'active':_vm.data.enabled}, _vm.data.color]}),_vm._v(" "),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }